<a class="mvd_navbar__link" href="javascript:void(0);">
    <span class="heartbeat--loading" title="Loading Connection Status..." *ngIf="!styleClass"></span>
    <span [ngClass]="styleClass" title="{{statusMessage}}" (click)="openModal()" *ngIf="styleClass"><i class="material-icons">favorite</i></span>
</a>